<template>
    <div class="learning-system">
        <div v-show="!isOk">
            <h2>客户端启动中...</h2>
        </div>
        <div v-show="isOk">
            <div id="download" style="display:block;font-size:16px;text-align:center;margin-bottom:60px" class="div">
                <h2>未安装客户端</h2>系统检测到您还未安装客户端，
                <p></p>
                <a style="font-size:14px;color:blue;" :href="downloadUrl" download="">点击这里</a>下载安装客户端，
                <p></p>
                <a style="font-size:14px;color:blue;" href="javascript:" class="goA">点击这里</a>进入客户端
                <p></p>
                <!-- 课程学习需要Flash <a style="font-size:14px;color:blue;" :href="downloadFlash" download="flash.exe">点击这里</a> -->
            </div>
            <div id="go" style="display:none;font-size:16px;text-align:center;margin-bottom:60px;" class="div">
                <h2>进入学习客户端</h2>客户端已自动启动，如未启动，
                <p></p>
                <a style="font-size:14px;color:blue;" href="javascript:" class="goA">点击这里</a>手动启动，或
                <p></p>
                <a style="font-size:14px;color:blue;" :href="downloadUrl" download="studyPlugin.exe">点击这里</a>下载安装客户端
                <p></p>
                <!-- 课程学习需要Flash <a style="font-size:14px;color:blue;" :href="downloadFlash" download="flash.exe">点击这里</a> -->
            </div>

            <div id="liulanqi" style="display:none;font-size:16px;text-align:center;margin-bottom:60px;" class="div">您的浏览器版本过低,请下载最新版本的浏览器</div>
        </div>

        <iframe src frameborder="0" id="enterStudyPlugin" style="display:none"></iframe>
    </div>
</template>
<script>
import config from "@/utils/config"
export default {
    props: {
        url: String
    },
    data () {
        return {
            isOk: false,
            downloadUrl: "",
            downloadFlash: config.resourceUrl + '/client/flash_player.exe'
        }
    },
    created () {
        this.$ajax
            .post(
                "/compute-oper-service/TbAppManage/downloadApp",
                this.postData({
                    type: 1
                })
            )
            .then(res => {
                this.downloadUrl = this.filesDownload(res.data.filePath)
            })
    },

    mounted () {
        let url_ = this.url
        $(".goA").click(function () {
             $("#enterStudyPlugin").attr("src",url_)

            // _this.chackWs(function () {
            //      let token = sessionStorage.getItem('token')
            //      console.log(token,"token");
            //     window.protocolCheck(`learningSystem://${token}`)
            //     console.log(url)
            //     window.protocolCheck(url)
            //     window.location.href = url
            // })
        })

        this.openUriWithInputTimeoutHack(url_, () => {
            console.log('检测到，未安装客户端')
            this.isOk = true,
            $("#download").css("display", "block")
            $("#go").css("display", "none")
        }, () => {
            // 浏览器弹窗提示
            console.log('检测到：已安装了客户端')
            this.isOk = true,
            $("#download").css("display", "none")
            $("#go").css("display", "block")
        })
    },
    methods: {
        chackWs (callback) {
            var host = "ws://127.0.0.1:16857"
            var Socket = new WebSocket(host)
            Socket.onopen = function (msg) {
                alert("客户端已启动")
            }
            Socket.onclose = function (msg) { }
            Socket.onerror = function (msg) {
                console.log(isFtAvailable("AetsAssistant Calligraphr"),'isFtAvailable("AetsAssistant Calligraphr")');
                if (isFtAvailable("AetsAssistant Calligraphr")) {
                    $("#download").css("display", "none")
                    $("#go").css("display", "block")
                    callback()
                } else {
                    $("#download").css("display", "block")
                    $("#go").css("display", "none")
                    callback()
                }
            }
            setTimeout(() => {
                Socket.close()
            }, 2000)
        },

        openUriWithInputTimeoutHack(uri, failCb, successCb) {
            let target = document.createElement('input')
            target.style.width = '0'
            target.style.height = '0'
                target.style.position = 'fixed'
            target.style.top = '0'
            target.style.left = '0'
            document.body.appendChild(target)

            target.focus();
            var handler = this._registerEvent(target, "blur", onBlur);
            console.log('focus')
            function onBlur() {
                console.log('blur')
                successCb && successCb()
                handler.remove()
                clearTimeout(timeout)
                document.body.removeChild(target)
            };

            //will trigger onblur
            location.href = uri

            // Note: timeout could vary as per the browser version, have a higher value
            var timeout = setTimeout(function () {
                console.log('setTimeout')
                failCb && failCb()
                handler.remove()
                document.body.removeChild(target)
            }, 10000);
        },
        _registerEvent(target, eventType, cb) {
            if (target.addEventListener) {
                target.addEventListener(eventType, cb);
                return {
                    remove: function () {
                        target.removeEventListener(eventType, cb);
                    }
                };
            } else {
                target.attachEvent(eventType, cb);
                return {
                    remove: function () {
                        target.detachEvent(eventType, cb);
                    }
                };
            }
        },



    }
};
</script>
<style lang="scss">
.learning-system h2 {
    text-align: center;
    margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/learnCenter/learningSystem.vue